// @flow

import * as React from 'react';
import Pie from './Pie';
import './FertilityByAge.scss';

const config = [
  {
    // chance: '85',
    color: 'dark_blue',
    range: '19-34',
  },
  {
    // chance: '70',
    color: 'light_blue',
    range: '35-39',
  },
  {
    // chance: '50',
    color: 'light_green',
    range: '40-44',
  },
  {
    // chance: '5',
    color: 'orange',
    range: '45-50',
  },
];

// safe to use 'to' since this page is currently English only
const screenReaderSanitizer = (str: string): string => (str.replace(/<br \/>|<br\/>|<b>|<\/b>/gi, '').replace('-', ' to '));

type Props = {
  content: [Object],
};

type State = {
  selectedButton: number,
};

class FertilityByAge extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { selectedButton: 0 };
    this.propsForPie = this.propsForPie.bind(this);
  }

  handleChange(event: Object) {
    const pos = parseInt(event.target.getAttribute('position'), 10);
    this.setState({ selectedButton: pos });
  }

  propsForPie(): Object {
    const position = this.state.selectedButton;

    // console.log(this.props.content);
    // console.log(position);

    const props = config[position];
    ['chance', 'prefix', 'postfix', 'displayChance'].forEach((key: string) => {
      props[key] = this.props.content[position][key];
    });

    // console.log(props);

    return props;
  }

  render() {
    const { content: chart } = this.props;
    const tabs = (): React.Node => (
      config.map((pie: Object, idx: number): React.Element<'button'> => {
        const ariaLabel = screenReaderSanitizer(`${chart[idx].prefix} ${chart[idx].chance}% chance ${chart[idx].postfix}`);

        return (
          <button
            className={`${pie.color} ${idx === this.state.selectedButton && 'active'}`}
            onClick={(e: SyntheticEvent<HTMLButtonElement>) => { this.handleChange(e); }}
            position={idx}
            aria-pressed={idx === this.state.selectedButton}
            key={pie.range}
            type="button"
            aria-label={ariaLabel}
          >
            {pie.range}
          </button>
        );
      })
    );

    return (
      <section id="fertility-by-age">
        <fieldset className="button-bar">
          {tabs()}
        </fieldset>
        <Pie {...this.propsForPie()} ariaHidden />
      </section>
    );
  }
}

export default FertilityByAge;
